import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    difImageContainer: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
    },
    droppleContainer: {
      width: '100%',
    },
    notShowonReportContainer: {
      maxHeight: '360px',
      maxWidth: '310px',
      height: '100%',
      width: '100%',
      padding: 8,
      borderRadius: '4px',
    },
  }),
);

export default useStyles;
